import { Button, Card, Space, Typography } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import { EyebrowLabel } from '@viq-admin/ui';
import type { LeadDetail } from './types';

interface Props {
  rawnotes: LeadDetail['rawnotes'];
  /**
   * Optional edit closure. Absent → today's exact read-only render, which is
   * what `stakeholder` and an ability-less console actor get.
   *
   * Receives the id of the note THIS PANEL RENDERED. "AI Summary" is not a
   * per-lead field — it is one rawnote's `summary` column — so the edit has to
   * name the row it came from or it would silently write to the wrong note.
   */
  onEdit?: (noteId: string, currentSummary: string) => void;
}

export function AiSummary({ rawnotes, onEdit }: Props) {
  // rawnotes are already ordered DESC by the backend; pick the first non-null summary.
  const note = rawnotes.find((r) => r.summary != null);

  return (
    <Card size="small">
      <Space style={{ width: '100%', justifyContent: 'space-between' }}>
        <EyebrowLabel>AI Summary</EyebrowLabel>
        {note && onEdit && (
          <Button
            type="text"
            size="small"
            icon={<EditOutlined />}
            aria-label="Edit summary"
            onClick={() => onEdit(note.id, note.summary ?? '')}
          />
        )}
      </Space>
      {note ? (
        <Typography.Paragraph style={{ margin: 0 }}>
          {note.summary}
        </Typography.Paragraph>
      ) : (
        <Typography.Text type="secondary">
          No AI summary yet — rawnotes pending enrichment.
        </Typography.Text>
      )}
    </Card>
  );
}
